
import React, { useState, useEffect } from 'react';
import { Theme } from '../types';
import { InstagramIcon, LinkedinIcon, WhatsappIcon } from './icons';

interface FooterProps {
  theme: Theme;
}

const Footer: React.FC<FooterProps> = ({ theme }) => {
  const textColorClass = theme === 'dark' ? 'text-hba-text-secondary' : 'text-gray-500';
  const linkColorClass = theme === 'dark' ? 'text-hba-accent-pink hover:text-hba-accent-purple' : 'text-hba-accent-purple hover:text-purple-700';
  const headingColorClass = theme === 'dark' ? 'text-hba-text-primary' : 'text-gray-700';
  const bgColorClass = theme === 'dark' ? 'bg-hba-mid-purple' : 'bg-gray-100';
  const borderColorClass = theme === 'dark' ? 'border-hba-light-purple' : 'border-gray-300';

  // Contador simulado de visitas para efecto visual minimalista
  const [visitCount, setVisitCount] = useState<number>(12450);

  useEffect(() => {
    // Simulamos un contador persistente en localStorage
    try {
      const storedVisits = localStorage.getItem('hba_visit_counter');
      let count = 12450; // Número base arbitrario para empezar
      if (storedVisits) {
        count = parseInt(storedVisits, 10) + 1;
      }
      setVisitCount(count);
      localStorage.setItem('hba_visit_counter', count.toString());
    } catch (e) {
      // Fallback si falla localStorage
    }
  }, []);

  return (
    <footer className={`py-10 px-4 ${bgColorClass} ${textColorClass} border-t ${borderColorClass}`}>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8 text-center md:text-left">
          {/* Column 1: Brand */}
          <div>
            <a href="https://housebuenosaires.com/" target="_blank" rel="noopener noreferrer" className={`text-xl font-bold ${headingColorClass} hover:opacity-80 transition-opacity`}>
              HBA Creative Group
            </a>
            <p className="text-sm mt-1">By Aldo Irazoqui</p>
            <p className="text-xs mt-3">Palermo, Buenos Aires</p>
            
            {/* Minimalist Visit Counter */}
            <p className="text-[10px] uppercase tracking-widest mt-2 opacity-40 font-mono">
              Visitas: {visitCount.toLocaleString()}
            </p>
          </div>

          {/* Column 2: Contact */}
          <div>
            <h3 className={`text-md font-semibold mb-3 ${headingColorClass}`}>Contacto</h3>
            <ul className="space-y-1 text-sm">
              <li>
                <a href="mailto:contacto@housebuenosaires.com" className={linkColorClass}>
                  contacto@housebuenosaires.com
                </a>
              </li>
              <li>
                <a href="https://wa.link/2eec1a" target="_blank" rel="noopener noreferrer" className={linkColorClass}>
                  WhatsApp: +54 11 35647277
                </a>
              </li>
               <li>
                <a href="https://housebuenosaires.com/" target="_blank" rel="noopener noreferrer" className={linkColorClass}>
                  Web: housebuenosaires.com
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Social Media */}
          <div>
            <h3 className={`text-md font-semibold mb-3 ${headingColorClass}`}>Síguenos</h3>
            <div className="flex justify-center md:justify-start space-x-4">
              <a href="https://www.instagram.com/hbadjs/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className={`${linkColorClass} transition-transform hover:scale-110`}>
                <InstagramIcon className="w-6 h-6" />
              </a>
              <a href="https://www.linkedin.com/in/aldoirazoqui/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className={`${linkColorClass} transition-transform hover:scale-110`}>
                <LinkedinIcon className="w-6 h-6" />
              </a>
              {/* WhatsApp icon already in contact, can be removed here if redundant or kept for visual consistency */}
              <a href="https://wa.link/2eec1a" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className={`${linkColorClass} transition-transform hover:scale-110`}>
                <WhatsappIcon className="w-6 h-6" />
              </a>
            </div>
          </div>
        </div>

        <div className={`text-center text-xs pt-6 border-t ${borderColorClass}`}>
          &copy; {new Date().getFullYear()} HBA Creative Group. Todos los derechos reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
